const smoothScroll = (el, offset) => {
    if (!el) return
    const elementPosition = el.offsetTop - offset
    window.scroll({
        top: elementPosition,
        left: 0,
        behavior: 'smooth',
    })
}

export default smoothScroll
